/**
 * DevExtreme (esm/renovation/component_wrapper/scheduler/header_panel.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import Component from "../common/component";
export class HeaderPanel extends Component {
    _setOptionsByReference() {
        super._setOptionsByReference();
        this._optionsByReference = _extends({}, this._optionsByReference, {
            dateHeaderData: true,
            resourceCellTemplate: true,
            dateCellTemplate: true,
            timeCellTemplate: true
        })
    }
}
